import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import { Fragment } from "react";
import { useCitadel } from "@/hooks/use-citadel";
import { AddAttendanceModal } from "@/modals/users/add-attendance-modal";

/** Props Interface */
interface UserAttendancesMenuProps {
	userId: string;
}

export function UserAttendancesMenu({ userId }: UserAttendancesMenuProps) {
	/** Context */
	const { refetch } = useDataTableContext();

	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();
	const { citadel } = useCitadel();

	/** Computed */
	// The route admits a member for their own sheet and a personnel role for anybody's, the rule
	// bound to the person the sheet is about. A rule list still loading is not a denial.
	const createIsDenied =
		!!citadel && citadel.cannot("create", "Attendance", { orgId: citadel.orgId, userId });

	/** Render */
	return (
		<Fragment>
			<Button
				variant="primary"
				onClick={disclosure.onOpen}
				icon={<Icon name="Plus" />}
				isDisabled={createIsDenied}
			>
				{t("users.add_attendance")}
			</Button>
			{disclosure.isOpen && (
				<AddAttendanceModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					userId={userId}
					onComplete={refetch}
				/>
			)}
		</Fragment>
	);
}
